import React from 'react';
import Notice from '../misc/Notice/Notice';

function InlineErrors({ messages, ...props }) {
  return (
    <div {...props} className="group__errors">
      {messages.map((message, index) => {
        return (
          <Notice key={index} type={'warning-alert'}>
            {message}
          </Notice>
        );
      })}
    </div>
  );
}

export default InlineErrors;
